import { usePermissions } from '@providers/userContextProvider';

export const useAlertBannerPermissions = () => {
  const { permissions } = usePermissions();

  const hasWriteBannersPermission = permissions.includes('write:alert_banners');
  const hasReadBannersPermission = permissions.includes('read:alert_banners');
  const hasTransitionBannersPermissions = permissions.includes(
    'transition:alert_banners',
  );

  return {
    hasWriteBannersPermission,
    hasReadBannersPermission,
    hasTransitionBannersPermissions,
  };
};
